import { General_Interface } from "./General_Interface";

export interface Address_Interface {

  id:number,
  title:string,
  title_id:number,
  address:string,
  certificateAddress:string,
  certificateAddress_en:string,
  codepost:number,
  sandoghpost:number,
  pishShomareh:number,

  tel: Array<General_Interface>,
  tel_temp: string,

  email: Array<General_Interface>,
  email_temp: string,

  dakheli:number,
  fax:number,
  dsc:string,
}

export function Empty_Address_Interface():Address_Interface{
  return{
    id:0,
    title:'',
    title_id:0,
    address:'',
    certificateAddress:'',
    certificateAddress_en:'',
    codepost:0,
    sandoghpost:0,
    pishShomareh:0,
    tel: [],
    tel_temp: '-1',

    email: [],
    email_temp:'-1',

    dakheli:0,
    fax:0,
    dsc:'',
  }
}
